const BANANA_BLOCKS_BASE_URL = 'https://bananablocks.com'

export const bsvTxExplorerUrl = (txId?: string | null) =>
    txId ? `${BANANA_BLOCKS_BASE_URL}/tx/${txId}` : undefined
